export const parseProductOptionsToEntries = (value: string = "") => {
  return value
    .split(";")
    .filter((_) => _)
    .map((option) => option.split(":").map((s) => s.trim()));
};
